// Supported quote currencies. Prices are always entered in AED and
// converted to the selected currency using the FX rate locked at build time.
export const CURRENCIES = [
  { code: "AED", label: "UAE Dirham", symbol: "AED" },
  { code: "USD", label: "US Dollar", symbol: "USD" },
  { code: "EUR", label: "Euro", symbol: "EUR" },
  { code: "OMR", label: "Omani Rial", symbol: "OMR" },
  { code: "QAR", label: "Qatari Riyal", symbol: "QAR" },
  { code: "SAR", label: "Saudi Riyal", symbol: "SAR" },
  { code: "KWD", label: "Kuwaiti Dinar", symbol: "KWD" },
  { code: "BHD", label: "Bahraini Dinar", symbol: "BHD" },
  { code: "INR", label: "Indian Rupee", symbol: "INR" },
  { code: "JPY", label: "Japanese Yen", symbol: "JPY" },
];

export const findCurrency = (code) =>
  CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];

// Convert AED amount to the target currency using the given AED->target fx_rate.
// If rate is missing or the target is AED, returns the input unchanged.
export const convertFromAED = (aedAmount, fx_rate, currency) => {
  const n = Number(aedAmount || 0);
  if (!currency || currency === "AED") return n;
  const r = Number(fx_rate);
  if (!isFinite(r) || r <= 0) return n;
  return n * r;
};

export const formatMoney = (n, currency = "AED") => {
  const val = Number(n || 0);
  // Use plain locale formatting; currency code shown separately as a suffix
  // to keep the layout consistent with existing print styling.
  const decimals = ["JPY", "INR"].includes(currency) ? 2 : 2;
  return val.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};
